import React from 'react';
//
import { useDispatch } from 'react-redux';
// Router
import { useHistory } from 'react-router';
//
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
// API
import tourPrevAPI from 'app/API/tour.prev.api';
// Action
import {
  markJustImportedTour,
  setMainPartTitle,
} from 'app/actions/FullTour/full_tour_view.action';

// Translation
import withTranslations from 'app/components/HOGs/withTranslations';
// ANTD
import { Upload, Button, message } from 'antd';
//
import { ImportGpsFile } from './svg';

const GpxUpload = (props) => {
  const { tr } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const onChangeTitle = (str) => {
    dispatch(setMainPartTitle(str));
  };

  return (
    <Upload
      className="uploadContent"
      accept=".gpx, .gdb, .itn, .kml"
      name="file"
      action={tourPrevAPI.getUrlUploadGps()}
      withCredentials
      defaultFileList={[]}
      onChange={(info) => {
        const { status, response } = info.file;
        if (status === 'done') {
          const { code, body } = response;
          if (code === 200) {
            const { title, points, type, url } = body;
            if (type === 'imported') {
              dispatch(markJustImportedTour(true));
              history.push(url);
            } else {
              const len = points.length;
              if (len > 0) {
                publish(way.DRIVE_MAP_UPLOAD_GPS_DATA, { points });
              } else {
                message.info(tr["There aren't points in the loaded GPS data"]);
              }
              if (title) onChangeTitle(title);
            }
          } else {
            console.log(response);
          }
        } else if (status === 'error') {
          message.error(`${info.file.name} ${tr['file upload failed.']}`);
        }
      }}
    >
      <Button className="tour-import-gps-file">
        <ImportGpsFile />
        {tr['Import GPS file']}
      </Button>
    </Upload>
  );
};

export default withTranslations(GpxUpload);
